import { feedbackCreate } from '@/entities/feedbacks'
import { PrimaryButton, SelfValidateTextArea } from '@/shared/ui'
import { PaperClipOutlined, SendOutlined } from '@ant-design/icons'
import { Flex } from 'antd'
import { useUnit } from 'effector-react'

import { MAX_MESSAGE_LENGTH } from '../../lib/constants'
import { $fileSubmiting } from '../../model/attachment-upload.model'
import {
  $currentFeedbackInput,
  $loadingChatInitially,
  changeCurrentFeedbackInput,
  feedbackChatMessageSubmit,
} from '../../model/feedback-chat.model'
import { AttachmentInput } from '../AttachmentInput'
import styles from './styles.module.scss'

interface FeedbackChatInputProps extends React.HTMLAttributes<HTMLDivElement> {
  onHeightChange: () => void
}
export function FeedbackChatInput({
  onHeightChange,
  ...rest
}: FeedbackChatInputProps) {
  const { text } = useUnit($currentFeedbackInput)
  const [
    handleChange,
    handleSubmit,
    messageSubmitting,
    fileSubmiting,
    loadingChatInitially,
  ] = useUnit([
    changeCurrentFeedbackInput,
    feedbackChatMessageSubmit,
    feedbackCreate.$pending,
    $fileSubmiting,
    $loadingChatInitially,
  ])
  const submitting = messageSubmitting || fileSubmiting
  const loading = submitting || loadingChatInitially
  const showCount = text.length > MAX_MESSAGE_LENGTH * 0.9
  return (
    <Flex className={styles.inputWrapper + ' ' + (rest.className || '')}>
      <AttachmentInput>
        <PrimaryButton
          disabled={loading}
          variant="link"
          icon={<PaperClipOutlined />}
          className={styles.attachButton}
        />
      </AttachmentInput>

      <SelfValidateTextArea
        className={styles.textArea}
        placeholder="Напишите сообщение..."
        size="large"
        value={text}
        maxLength={MAX_MESSAGE_LENGTH}
        onChange={(value) => {
          handleChange({ text: value })
        }}
        onTransitionEnd={onHeightChange}
        autoSize={{ minRows: 1, maxRows: 5 }}
        disabled={loading}
        correctOnKeyDown={false}
        showCount={showCount}
      />
      <PrimaryButton
        variant="link"
        icon={<SendOutlined />}
        onClick={handleSubmit}
        disabled={!text.trim() || text.length > MAX_MESSAGE_LENGTH || loading}
        loading={submitting}
        className={styles.sendButton}
      />
    </Flex>
  )
}
